import { HIGHLIGHT_PATH } from '../../constants'
import getInstanceIdsReduxSelector from '../../../../redux/selectors/get-instance-ids'

const getHighlightIdsSelector = getInstanceIdsReduxSelector(HIGHLIGHT_PATH.DATA,
  HIGHLIGHT_PATH.ALL_DATA
)

export default getHighlightIdsSelector
